<app-classify-form-wrapper
  #formWrapper
  [config]="config"
  [editMode]="false"
  [viewMode]="false"
></app-classify-form-wrapper>
